// src/services/api/products.js
import { apiClient } from './base';

export const createProduct = async (productData) => {
  try {
    const response = await apiClient.post('/products', productData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProducts = async (params = {}) => {
  try {
    const response = await apiClient.get('/products', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProduct = async (productId) => {
  try {
    const response = await apiClient.get(`/products/${productId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateProduct = async (productId, productData) => {
  try {
    const response = await apiClient.put(`/products/${productId}`, productData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteProduct = async (productId) => {
  try {
    const response = await apiClient.delete(`/products/${productId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateProductStatus = async (productId, visibility) => {
  try {
    const response = await apiClient.patch(`/products/${productId}/status`, { visibility });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const duplicateProduct = async (productId) => {
  try {
    const response = await apiClient.post(`/products/${productId}/duplicate`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkProductSku = async (sku, productId = null) => {
  try {
    const params = { sku };
    if (productId) {
      params.productId = productId;
    }
    const response = await apiClient.get('/products/check-sku', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkProductBarcode = async (barcode, productId = null) => {
  try {
    const params = { barcode };
    if (productId) {
      params.productId = productId;
    }
    const response = await apiClient.get('/products/check-barcode', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get inventory alerts for low stock and out of stock items
 * @param {Object} params - Query parameters
 * @param {number} params.warehouseId - Optional warehouse filter
 * @param {number} params.lowStockThreshold - Threshold for low stock alert (default: 10)
 * @returns {Promise<Object>} Summary counts and lists of low stock and out of stock items
 */
export const getInventoryAlerts = async (params = {}) => {
  try {
    const response = await apiClient.get('/products/inventory-alerts', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Bulk import (upsert by SKU) simple products.
 * @param {number[]} shopIds - Shops to apply row pricing to
 * @param {number|null} warehouseId - Warehouse for opening stock
 * @param {Array} rows - Parsed sheet rows, each with a rowNumber
 * @param {boolean} dryRun - Validate only, no writes
 */
export const bulkImportProducts = async (shopIds, warehouseId, rows, dryRun = false) => {
  try {
    const response = await apiClient.post('/products/bulk', {
      shopIds,
      warehouseId,
      rows,
      dryRun,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};